export default "__VITE_ASSET__BfO$ZxBo__"